/**
 * 服务与支持 postMessage
 * 参考文档：https://ku.baidu-int.com/knowledge/HFVrC7hq1Q/-ikorFqd5i/wKWO72VC7h/usqm9lubkTPOTf
 */
import ENV_CONFIG from '@/config';

type Channel = 'jump' | 'link' | 'ticketRouterCache' | 'closeSkeleton';
type Show = 'newPage' | 'miniWindow' | undefined;

interface Data {
    url?: string;
    show?: Show;
    router?: string;
}

interface Query {
    [x: string]: any;
}

const getQueryString = (query: Query) => {
    const keys = Object.keys(query);
    const length = keys.length;
    if (length === 0) {
        return '';
    }
    const queryStrArr = keys.reduce((prev, curr) => {
        if (!curr || ['', null, undefined].includes(query[curr])) {
            return prev;
        }
        const str = `${curr}=${encodeURIComponent(String(query[curr]))}`;
        prev.push(str);
        return prev;
    }, [] as string[]);
    return `?${queryStrArr.join('&')}`;
};

const postSupportMessage = (channel: Channel, data: Data) => {
    window.parent.postMessage({
        channel,
        data,
    }, '*');
    // ENV_CONFIG.SUPPORT_HOST
};

// 跳转服务与支持-工单页面
export const postSupportTicketUrl = (path: string, query?: Query) => {
    const queryString = getQueryString(query || {});
    postSupportMessage('jump', {
        url: `/ticket/#${path}${queryString}`,
    });
};

// 跳转服务与支持-智能助手页面
const postSupportZnzsUrl = (query: Query, show?: Show) => {
    const queryString = getQueryString(query);
    postSupportMessage('jump', {
        url: `/znzs/#/znzs${queryString}`,
        show,
    });
};

// 跳转助手
export const openZnzsUrl = (query: Query) => {
    if (window.isSupportIframe) {
        postSupportZnzsUrl(query);
    }
    else {
        // 用于本地测试
        const queryString = getQueryString(query);
        window.open(`${ENV_CONFIG.SUPPORT_HOST}/#/znzs${queryString}`);
    }
};
// 跳转助手，新开页面
export const openZnzsUrlNewPage = (query: Query) => {
    if (window.isSupportIframe) {
        postSupportZnzsUrl(query, 'newPage');
    }
    else {
        // 用于本地测试
        const queryString = getQueryString(query);
        window.open(`${ENV_CONFIG.SUPPORT_HOST}/#/znzs${queryString}`);
    }
};

// 跳转其他链接（文档、非文档等链接）
export const postSupportOtherUrl = (url: string, openNewPage: boolean = true) => {
    postSupportMessage('link', {
        url,
        show: openNewPage ? 'newPage' : 'miniWindow',
    });
};

// a标签被点击时，拦截处理
export const linkClickOpen = (url: string, openNewPage: boolean = false) => {
    if (!url) {
        return;
    }
    if (openNewPage) {
        // 新开页面，就不用判断了
        return postSupportOtherUrl(url, true);
    }
    const ticketHost = `${ENV_CONFIG.CONSOLE_HOST}/ticket`;
    // 情况判断
    if (url.startsWith(ticketHost) && window.URL) {
        // 点击的工单自己的链接
        const location = new window.URL(url);
        const path = location.hash.replace('#', '');
        return postSupportTicketUrl(path);
    }
    // 其他链接
    postSupportOtherUrl(url, false);
};

// 关闭支持的骨架屏
export const closeSupportSkeleton = () => {
    postSupportMessage('closeSkeleton', {});
};
